import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
interface Perk {
  id: number;
  name: string;
  iconPath: string;
}
interface PerkStyle {
  id: number;
  name: string;
  tooltip: string;
  iconPath: string;
}
interface PerkData {
  perks: Perk[];
  styles: PerkStyle[];
}
const fetchPerksData = async (): Promise<PerkData> => {
  const [perksResponse, stylesResponse] = await Promise.all([fetch("https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/v1/perks.json"), fetch("https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/v1/perkstyles.json")]);
  if (!perksResponse.ok) {
    throw new Error("Failed to fetch perks");
  }
  if (!stylesResponse.ok) {
    throw new Error("Failed to fetch perk styles");
  }
  const [perks, stylesData] = await Promise.all([perksResponse.json(), stylesResponse.json()]);
  return {
    perks,
    styles: stylesData.styles
  };
};
export const usePerks = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["perks-data"],
      queryFn: fetchPerksData,
      staleTime: 3600000
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
};